import React, { useState, useEffect } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Service from "./components/Service";
import About from "./components/About";
import ContactUs from "./components/ContactUs";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Careers from "./components/Careers";
import Business from "./components/Buisness";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import FAQSection from "./components/FAQSection";

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showContactOnly, setShowContactOnly] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktopModeOnMobile, setIsDesktopModeOnMobile] = useState(false);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const updateSize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleScrollToSection = (id) => {
    if (showContactOnly) {
      setShowContactOnly(false);
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const handleKnowMoreClick = () => {
    setShowContactOnly(true);
  };

  const checkDesktopMode = () => {
    const newViewportWidth = window.innerWidth;
    const newScreenWidth = window.screen.width;
    const userAgent = navigator.userAgent;

    const mobileCheck =
      /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
      navigator.maxTouchPoints > 1;

    const desktopMode = mobileCheck && newViewportWidth > newScreenWidth;

    setIsMobile(mobileCheck);
    setViewportWidth(newViewportWidth);
    setScreenWidth(newScreenWidth);
    setIsDesktopModeOnMobile(desktopMode);
  };

  useEffect(() => {
    checkDesktopMode();
    const handleResize = () => {
      setTimeout(() => {
        checkDesktopMode();
      }, 500);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const screenInfo = {
    isDesktopModeOnMobile,
    width,
  };

  return (
    <div className="w-full">
      <Router>
        <Navbar
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          handleScrollToSection={handleScrollToSection}
        />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <div id="home" className="w-full bg-[#080C26]">
                  <Home screenInfo={screenInfo} />
                </div>
                <div
                  id="about"
                  className="w-full bg-gradient-to-b from-[#080C26] to-[#1B0784]"
                >
                  <About screenInfo={screenInfo} />
                </div>
                <div
                  id="services"
                  className="w-full bg-gradient-to-b to-[#5340B5] from-[#1B0784]"
                >
                  <Service screenInfo={screenInfo} />
                </div>
                <div id="careers" className="w-full bg-[linear-gradient(180deg,_rgba(83,64,181,1)_20%,_rgba(27,7,132,1)_100%)]">
                  <Careers screenInfo={screenInfo} />
                </div>
                <div
                  id="business"
                  className="w-full bg-gradient-to-b from-[#1B0784] to-[#080C26]"
                >
                  <Business screenInfo={screenInfo} />
                </div>
                <div
                  id="FAQSection"
                  className="w-full  bg-[#080C26]"
                >
                  <FAQSection screenInfo={screenInfo} />
                </div>
                <div id="footer" className="w-full h-full">
                  <Footer handleScrollToSection={handleScrollToSection} />
                </div>
              </>
            }
          />
          <Route path="/contact" element={<ContactUs   screenInfo={screenInfo} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
